<template>
    <div class="home">
        <!-- 年度top奖励 -->
        <listBg>
            <div class="rank_contain">
                <div class="title public_flex_center">
                    <div class="bg public_flex_center">{{ MIXIN_TEXT[3] }}</div>
                    <div class="up public_flex_center">{{ MIXIN_TEXT[3] }}</div>
                </div>

                <div class="swiper_box public_flex_center">
                    <div class="slide_item" v-for="(item, index) in giftInfoList">
                        <div class="gift_bg">
                            <div class="img public_flex_center">
                                <img class="gift_img" :src="'https://oss-image.voicemaker.media/'+item.image" />
                            </div>
                            <div class="name public_flex_center">
                                <NoticeBar class="notice" :notice="MIXIN_TEXT[rewardTypeName[item.goodId]]" />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="view_all public_flex_center" @click="fnGoApp" v-animate>{{ MIXIN_TEXT[54] }}</div>
            </div>
        </listBg>

        <!-- 赛程赛制 -->
        <listBg>
            <div class="rank_contain">
                <div class="title public_flex_center">
                    <div class="bg public_flex_center">{{ MIXIN_TEXT[13] }}</div>
                    <div class="up public_flex_center">{{ MIXIN_TEXT[13] }}</div>
                </div>

                <!-- 主赛程 -->
                <div class="course_wrap">
                    <div class="course_title public_flex_center"><span>{{ MIXIN_TEXT[14] }}</span></div>
                    <div class="round_wrap">
                        <div class="shadow shadow1"></div>
                        <div class="shadow shadow2"></div>

                        <div class="round_list public_flex_start">
                            <div class="round_item" v-for="(item,index) in mainSchedule">
                                <div class="round_name">{{ MIXIN_TEXT[item.name] }}</div>
                                <div class="round_name">
                                    <template v-if="MIXIN_TEXT[item.rank]">
                                        <template v-if="item.rankNum.length===2">
                                            {{ MIXIN_TEXT[item.rank].replace('a%',item.rankNum[0]).replace('d%',item.rankNum[1]) }}
                                        </template>
                                        <template v-else>
                                            {{ MIXIN_TEXT[item.rank].replace('d%',item.rankNum[0]) }}
                                        </template>
                                    </template>
                                </div>
                                <div class="line" :class="['line'+(index+1)]"></div>
                                <uiImg n="crown1"></uiImg>
                                <div class="round_time">{{ MIXIN_TEXT[item.time] }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="tip">{{ MIXIN_TEXT[15] }}</div>
                </div>

                <!-- 区域单项赛 -->
                <div class="course_wrap course_wrap2" v-if="MIXIN_LANG !== 'BR'">
                    <div class="course_title public_flex_center"><span>{{ MIXIN_TEXT[28] }}</span></div>
                    <div class="round_wrap">
                        <div class="shadow shadow1"></div>
                        <div class="shadow shadow2"></div>

                        <div class="round_list" :class="[!singleSchedule[4].show ? 'public_flex_center' : 'public_flex_start']">
                            <template v-for="(item,index) in singleSchedule">
                                <div class="round_item" v-if="item.show===undefined||item.show===true">
                                    <div class="round_name">{{ MIXIN_TEXT[item.name] }}</div>
                                    <div class="line" :class="['line'+(index+1)]"></div>
                                    <uiImg n="crown1"></uiImg>
                                    <div class="round_time">{{ MIXIN_TEXT[item.time] }}</div>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="tip">{{ MIXIN_TEXT[33] }}</div>
                </div>

                <!-- 区域公会赛 -->
                <div class="course_wrap course_wrap3" v-if="!['JP','FR','DE','BR'].includes(MIXIN_LANG)">
                    <div class="course_title public_flex_center"><span>{{ MIXIN_TEXT[34] }}</span></div>
                    <div class="round_wrap">
                        <div class="shadow shadow1"></div>
                        <div class="shadow shadow2"></div>
                        <div class="round_list public_flex_center">
                            <div class="round_item" :class="{'round_item_single': unionSchedule.length===1}" v-for="(item,index) in unionSchedule">
                                <div class="round_name">{{ MIXIN_TEXT[item.name] }}</div>
                                <div class="round_name">
                                    <template v-if="MIXIN_TEXT[item.rank]">
                                        <template v-if="item.rankNum.length===2">
                                            {{ MIXIN_TEXT[item.rank].replace('a%',item.rankNum[0]).replace('d%',item.rankNum[1]) }}
                                        </template>
                                        <template v-else>
                                            {{ MIXIN_TEXT[item.rank].replace('d%',item.rankNum[0]) }}
                                        </template>
                                    </template>
                                </div>
                                <div class="line" :class="['line'+(index+1)]"></div>
                                <uiImg n="crown1"></uiImg>
                                <div class="round_time">{{ MIXIN_TEXT[item.time] }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="tip">{{ MIXIN_TEXT[35] }}</div>
                </div>

                <div class="view_all public_flex_center" @click="fnGoApp" v-animate>{{ MIXIN_TEXT[54] }}</div>
            </div>
        </listBg>

        <!-- 榜单玩法 -->
        <listBg>
            <div class="rank_contain">
                <div class="title public_flex_center">
                    <div class="bg public_flex_center">{{ MIXIN_TEXT[40] }}</div>
                    <div class="up public_flex_center">{{ MIXIN_TEXT[40] }}</div>
                </div>

                <!-- 活动礼物 -->
                <div class="course_wrap course_wrap4">
                    <div class="course_title public_flex_center"><span>{{ MIXIN_TEXT[41] }}</span></div>
                    <div class="tip tip4 public_flex_center">{{ MIXIN_TEXT[42] }}</div>

                    <div class="course_swiper_wrap public_flex_center">
                        <template v-if="rewardList.length > 4">
                            <div class="course_shadow course_shadow1"></div>
                            <div class="course_shadow course_shadow2"></div>
                            <carousel :mode="'singleSlide'" :swiper-config="{slidesPerView:4,allowTouchMove: true}" class="swiper_box">
                                <template #[`slide${index+1}`] v-for="(item, index) in rewardList">
                                    <div class="slide_item">
                                        <div class="gift_bg">
                                            <div class="img public_flex_center">
                                                <img class="gift_img" :src="'https://oss-image.voicemaker.media/'+item.image" />
                                            </div>
                                            <div class="name public_flex_center">
                                                <NoticeBar class="notice" :notice="MIXIN_TEXT[rewardTypeName[item.id]]" />
                                            </div>
                                            <div class="text">+{{ item.price }}</div>
                                        </div>
                                    </div>
                                </template>
                            </carousel>
                        </template>
                        <div class="swiper_box public_flex_center" v-else>
                            <div class="slide_item" v-for="(item, index) in rewardList">
                                <div class="gift_bg">
                                    <div class="img public_flex_center">
                                        <img class="gift_img" :src="'https://oss-image.voicemaker.media/'+item.image" />
                                    </div>
                                    <div class="name public_flex_center">
                                        <NoticeBar class="notice" :notice="MIXIN_TEXT[rewardTypeName[item.id]]" />
                                    </div>
                                    <div class="text">+{{ item.price }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 用户小时榜 -->
                <div class="course_wrap course_wrap5">
                    <div class="course_title public_flex_center"><span>{{ MIXIN_TEXT[43] }}</span></div>

                    <div class="course_swiper_wrap public_flex_center">
                        <div class="hour_icon">
                            <div class="num">
                                <div class="bg public_flex_center">????</div>
                                <div class="up public_flex_center">????</div>
                            </div>
                            <div class="num">
                                <div class="bg public_flex_center">{{ MIXIN_TEXT[45] }}</div>
                                <div class="up public_flex_center">{{ MIXIN_TEXT[45] }}</div>
                            </div>
                        </div>
                        <div class="text">{{ MIXIN_TEXT[44]&&MIXIN_TEXT[44].replace('xxxx', '????') }}</div>
                    </div>
                </div>
            </div>
        </listBg>

        <!-- 用户玩法 -->
        <listBg>
            <div class="rank_contain">
                <div class="title public_flex_center">
                    <div class="bg public_flex_center">{{ MIXIN_TEXT[46] }}</div>
                    <div class="up public_flex_center">{{ MIXIN_TEXT[46] }}</div>
                </div>

                <div class="user_play"></div>
                <div class="play_tip">{{ MIXIN_TEXT[47] }}</div>
            </div>
        </listBg>
        
    </div>
</template>
<script lang="ts" setup>
import { computed, ref } from 'vue';
import listBg from './components/listBg.vue';
import carousel from '@activity-business/h5-package-carousel';
import { rewardTypeName } from '../PreludeRank/utils/type';
import NoticeBar from './components/NoticeBar.vue';
import injectTool from './utils/injectTool';

const {TOOL_countryCode} = injectTool();

// 获取用户大区
const userArea = ref<string>(TOOL_countryCode);
// 区域赛主赛程
const mainSchedule = computed(() => {
    const jinji = {
        'EG': [800, 200, 10, 210, 500],
        'ME': [800, 200, 10, 210, 500],
        'TR': [500, 180, 10, 190, 500],
        'IN': [400, 150, 10, 160, 500],
        'ID': [200, 100, 10, 110, 500],
        'US': [150, 60,  5,  65 , 500],
        'NA': [150, 60,  5,  65 , 500],
        'PH': [150, 60,  5,  65 , 500],
        'VN': [300, 80,  10, 90 , 500],
        'TW': [500, 150, 10, 160, 500],
        'TH': [200, 80,  5,  85 , 500],
        'MY': [200, 50,  5,  55 , 500],
        'JP': [100, 50,  5,  55 , 500],
        'DE': [80,  20,  5,  25 , 500],
        'FR': [80,  20,  5,  25 , 500],
        'BR': [80,  20,  5,  25 , 500],
    }

    return [
        {name:16,rank:17,time:55,rankNum:[jinji[userArea.value][0]]},
        {name:18,rank:19,time:56,rankNum:[jinji[userArea.value][0],jinji[userArea.value][1]]},
        {name:20,rank:17,time:57,rankNum:[jinji[userArea.value][2]]},
        {name:22,rank:23,time:58,rankNum:[]},
        {name:24,rank:17,time:59,rankNum:[jinji[userArea.value][4]]},
        {name:26,rank:27,time:60,rankNum:[]},
    ]
}) 

// 区域赛单项赛
const singleSchedule = computed(() => [
    {name:29,rank:17,time:61},
    {name:30,rank:19,time:62},
    {name:80,rank:17,time:63},
    {name:31,rank:23,time:64,},
    {name:32,rank:23,time:65,show:userArea.value!='JP'},
])

// 区域赛公会赛
const unionSchedule = computed(() => {
    if (['EG','TR','ME'].includes(TOOL_countryCode)) return [
        {name:37,rank:90,time:66,rankNum:[]},
        {name:38,rank:91,time:67,rankNum:[]},
        {name:39,rank:92,time:68,rankNum:[]},
    ]

    return [
        {name:36,rank:81,time:69,rankNum:[]},
    ]
})

// 礼物信息
const giftInfoList:any[] = [
    {
        "uid": null,
        "area": null,
        "activityId": 0,
        "reason": 0,
        "gender": 0,
        "grade": 0,
        "index": 0,
        "stage": 0,
        "goodId": -9,
        "type": -1,
        "count": 1,
        "duration": 1,
        "durationHour": 0,
        "image": "/media/2024/11/26/ccca2c4cabc611ef941d0242c0a80004.png",
        "webp": null,
        "mp4": null,
        "key": null,
        "addScore": 0,
        "scoreRate": 0.0,
        "chatType": 0,
        "price": 0,
        "saveFlag": false,
        "discount": null,
        "originalPrice": null,
        "groupNumber": null,
        "rewardScene": null,
        "subRewardScene": null
    },
    {
        "uid": null,
        "area": null,
        "activityId": 0,
        "reason": 0,
        "gender": 0,
        "grade": 0,
        "index": 0,
        "stage": 0,
        "goodId": -10,
        "type": -1,
        "count": 1,
        "duration": 1,
        "durationHour": 0,
        "image": "/media/2024/11/26/e23561beabc611ef97d50242c0a80004.png",
        "webp": null,
        "mp4": null,
        "key": null,
        "addScore": 0,
        "scoreRate": 0.0,
        "chatType": 0,
        "price": 0,
        "saveFlag": false,
        "discount": null,
        "originalPrice": null,
        "groupNumber": null,
        "rewardScene": null,
        "subRewardScene": null
    },
    {
        "uid": null,
        "area": null,
        "activityId": 0,
        "reason": 0,
        "gender": 0,
        "grade": 0,
        "index": 0,
        "stage": 0,
        "goodId": -11,
        "type": -1,
        "count": 1,
        "duration": 1,
        "durationHour": 0,
        "image": "/media/2024/11/26/f545c4a6abc611ef8aaa0242c0a80004.png",
        "webp": null,
        "mp4": null,
        "key": null,
        "addScore": 0,
        "scoreRate": 0.0,
        "chatType": 0,
        "price": 0,
        "saveFlag": false,
        "discount": null,
        "originalPrice": null,
        "groupNumber": null,
        "rewardScene": null,
        "subRewardScene": null
    },
    {
        "uid": null,
        "area": null,
        "activityId": 0,
        "reason": 0,
        "gender": 0,
        "grade": 0,
        "index": 0,
        "stage": 0,
        "goodId": -12,
        "type": -1,
        "count": 1,
        "duration": 1,
        "durationHour": 0,
        "image": "/media/2024/11/26/047a19ccabc711efafbb0242c0a80002.png",
        "webp": null,
        "mp4": null,
        "key": null,
        "addScore": 0,
        "scoreRate": 0.0,
        "chatType": 0,
        "price": 0,
        "saveFlag": false,
        "discount": null,
        "originalPrice": null,
        "groupNumber": null,
        "rewardScene": null,
        "subRewardScene": null
    }
];
// 奖励预览
const rewardList:any[] = [
    {
        "mp4": "",
        "image": "/media/2024/11/27/13f204ccac8b11ef879a0242c0a80004.png",
        "abbreviationImage": "",
        "price": "10",
        "dynamic": "",
        "id": 20001624,
        "mp4Md5": ""
    },
    {
        "mp4": "",
        "image": "/media/2024/11/27/2c72009cac8b11ef98840242c0a80004.png",
        "abbreviationImage": "",
        "price": "2800",
        "dynamic": "",
        "id": 20001625,
        "mp4Md5": ""
    },
    {
        "mp4": "",
        "image": "/media/2024/11/27/32a9b86aac8b11ef879a0242c0a80004.png",
        "abbreviationImage": "",
        "price": "26000",
        "dynamic": "",
        "id": 20001626,
        "mp4Md5": ""
    },
    {
        "mp4": "",
        "image": "/media/2024/11/27/5236b6baac8b11ef873c0242c0a80004.png",
        "abbreviationImage": "",
        "price": "300000",
        "dynamic": "",
        "id": 20001628,
        "mp4Md5": ""
    },
    {
        "mp4": "",
        "image": "/media/2024/11/27/5841991cac8b11ef98840242c0a80004.png",
        "abbreviationImage": "",
        "price": "4999",
        "dynamic": "",
        "id": 20001634,
        "mp4Md5": ""
    }
];

// 分享页面中所有按钮点击事件都是此函数 打开app
const fnGoApp = () => {
    window.location.href = `https://sugo.onelink.me/gqNC/8d34d20a?source=invite`
}

</script>
<style lang='scss' scoped>
@use '@page/202411/PreludeRank/scss/public_mixin.scss' as *;

.home {
    padding-bottom: 1.68rem;

    .rank_contain {
        position: relative;
        width: 100%;
        min-height: 4.98rem;
        margin: auto;
        padding: 2.08rem 0 0.84rem;

        .title {
            position: absolute;
            width: 3.5rem;
            height: 0.7rem;
            top: 1.08rem;
            left: 0;
            right: 0;
            margin: auto;

            >div {
                width: 100%;
                height: 100%;
                font-size: 0.28rem;
                font-weight: 700;
                color: #FFB800;
                line-height: 0.3rem;
                text-align: center;
            }

            .up {
                position: absolute;
                background: linear-gradient(0deg, #ffbe43 30%, #FFF 85.48%);
                background-clip: text;
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                top: 0;
            }
        }

        .shadow {
            position: absolute;
            width: 0.72rem;
            height: 2.36rem;
            top: 1.28rem;
            z-index: 3;
            pointer-events: none;

            &.shadow1 {
                left: 0.16rem;
                @include bg('shadow1');
            }

            &.shadow2 {
                right: 0.16rem;
                @include bg('shadow2');
            }
        }

        .swiper_box {
            width: 6.69rem;
            margin: auto;

            .slide_item {
                margin: 0 0.02rem;

                .gift_bg {
                    width: 1.64rem;
                    height: 2.34rem;
                    @include bg('reward_bg');
                    padding-top: 0.1rem;

                    .img {
                        width: 1.34rem;
                        height: 1.34rem;
                        margin: auto;

                        img {
                            max-width: 100%;
                            max-height: 100%;
                        }
                    }

                }

                .name {
                    width: 1.4rem;
                    height: 0.7rem;
                    margin: 0.1rem auto 0;
                    color: #6600AE;
                    text-align: center;
                    font-size: 0.26rem;
                    font-weight: 700;

                    .notice {
                        height: 0.3rem;
                    }
                }
            }
        }

        .view_all {
            width: 3.26rem;
            height: 0.7rem;
            margin: 0.28rem auto 0;
            color: #811700;
            text-align: center;
            font-size: 0.28rem;
            font-weight: 700;
            @include bg('btn2');
        }

        .user_play {
            width: 6.62rem;
            height: 4.3rem;
            @include bg('user_play2');
            margin: 0.3rem auto 0.24rem;
            white-space: pre-wrap;
        }

        .play_tip {
            width: 6.2rem;
            color: #FFED8D;
            text-align: center;
            font-size: 0.24rem;
            margin: auto;
        }
    }

    .course_wrap {
        width: 6.5rem;
        height: 4.2rem;
        @include bg('course_wrap');
        margin: 0 auto 0.3rem;

        .course_title {
            width: 2.4rem;
            height: 0.64rem;
            margin: auto;

            span {
                position: relative;
                color: #FFED8D;
                text-align: center;
                font-size: 0.24rem;
                font-weight: 700;
                line-height: 0.24rem;

                &::before {
                    content: '';
                    position: absolute;
                    width: 0.75rem;
                    height: 0.28rem;
                    @include bg('course_title_dec1');
                    left: -0.9rem;
                    top: 0;
                    bottom: 0;
                    margin: auto;
                }

                &::after {
                    content: '';
                    position: absolute;
                    width: 0.75rem;
                    height: 0.28rem;
                    @include bg('course_title_dec2');
                    right: -0.9rem;
                    top: 0;
                    bottom: 0;
                    margin: auto;
                }
            }
        }

        .round_wrap {
            position: relative;
            width: 6.02rem;
            height: 2.02rem;
            @include bg('round_wrap');
            margin: 0.2rem auto;

            .shadow {
                position: absolute;
                width: 0.42rem;
                height: 100%;
                top: 0;
                z-index: 3;
                pointer-events: none;

                &.shadow1 {
                    left: 0;
                    @include bg('shadow3');
                }

                &.shadow2 {
                    right: 0;
                    @include bg('shadow4');
                }
            }

            .round_list {
                position: relative;
                width: 100%;
                height: 100%;
                padding: 0.22rem 0.24rem 0.2rem;
                flex-wrap: nowrap;
                overflow-x: scroll;
                gap: 0.1rem;

                .round_item {
                    position: relative;
                    min-width: 1.18rem;
                    text-align: center;
                    flex-shrink: 0;

                    .round_name {
                        height: 0.27rem;
                        color: #FFF5DA;
                        font-size: 0.24rem;
                        font-weight: 700;
                        line-height: 0.27rem;
                        margin: auto;
                        white-space: nowrap;
                    }

                    .line {
                        position: absolute;
                        width: 120%;
                        height: 0.06rem;
                        border-radius: 0.05rem;
                        background: #FFFB9D;
                        top: 0.94rem;
                        left: 0;

                        &.line1 {
                            width: 100%;
                            left: 45%;
                            background: linear-gradient(90deg, #FF00AC -22.09%, #FFA800 -7.14%, #ffab30 100%);
                        }

                        &.line2 {
                            background: linear-gradient(90deg, #ffab30 0%, #ffb53a 100%);
                        }

                        &.line3 {
                            background: linear-gradient(90deg, #ffb53a 0%, #ffce57 100%);
                        }

                        &.line4 {
                            background: linear-gradient(90deg, #ffce57 0%, #ffce57 100%);
                        }

                        &.line5 {
                            background: linear-gradient(90deg, #ffce57 0%, #ffc74f 100%);
                        }

                        &.line6 {
                            width: 50%;
                            background: linear-gradient(90deg, #ffc74f 0%, #FFFB9D 100%);
                        }
                    }

                    img {
                        position: relative;
                        display: block;
                        width: 0.74rem;
                        height: 0.74rem;
                        margin: 0.08rem auto 0;
                        z-index: 1;
                    }

                    .round_time {
                        color: #FFF5DA;
                        font-size: 0.22rem;
                        line-height: 0.26rem;
                        white-space: nowrap;
                    }

                    &:last-child {
                        .line {
                            width: 50%;
                            background: linear-gradient(90deg, #ffc74f 0%, #FFFB9D 100%);
                        }
                    }

                    &.round_item_single {
                        width: 100%;
                        .line {
                            width: 4.8rem;
                            left: 0;
                            right: 0;
                            margin: auto;
                            background: linear-gradient(90deg, #FF00AC -22.09%, #FFA800 -7.14%, #FFFB9D 100%);
                        }
                    }
                }
            }
        }

        .tip {
            width: 6.2rem;
            color: #FFED8D;
            text-align: center;
            font-size: 0.24rem;
            margin: auto;
            white-space: pre-wrap;

            &.tip4 {
                height: 1rem;
            }
        }

        &.course_wrap2 {
            .round_wrap {
                .round_list {
                    .round_item {
                        .line {
                            top: 0.67rem;

                            &.line2 {
                                background: linear-gradient(90deg, #FF00AC -22.09%, #FFA800 -7.14%, #ffb53a 100%);
                            }

                            &.line3 {
                                background: linear-gradient(90deg, #ffb53a 0%, #ffce57 100%);
                            }

                            &.line4 {
                                background: linear-gradient(90deg, #ffce57 0%, #ffc74f 100%);
                            }

                            &.line5 {
                                width: 50%;
                                background: linear-gradient(90deg, #ffc74f 0%, #FFFB9D 100%);
                            }
                        }

                        img {
                            position: relative;
                            display: block;
                            width: 0.74rem;
                            height: 0.74rem;
                            margin: 0.08rem auto 0;
                            z-index: 1;
                        }

                        .round_time {
                            color: #FFF5DA;
                            font-size: 0.22rem;
                            line-height: 0.26rem;
                            white-space: nowrap;
                        }
                    }
                }
            }

        }

        &.course_wrap3 {
            .round_wrap {
                .round_list {
                    gap: 0.2rem;

                    .round_item {
                        .line {
                            &.line2 {
                                background: linear-gradient(90deg, #FF00AC -22.09%, #FFA800 -7.14%, #ffb53a 100%);
                            }

                            &.line3 {
                                width: 50%;
                                background: linear-gradient(90deg, #ffb53a 0%, #ffce57 100%);
                            }
                        }

                        img {
                            position: relative;
                            display: block;
                            width: 0.74rem;
                            height: 0.74rem;
                            margin: 0.08rem auto 0;
                            z-index: 1;
                        }

                        .round_time {
                            color: #FFF5DA;
                            font-size: 0.22rem;
                            line-height: 0.26rem;
                            white-space: nowrap;
                        }
                    }
                }
            }

        }

        &.course_wrap4 {
            width: 6.5rem;
            height: 3.94rem;
            @include bg('course_wrap1');

            .course_swiper_wrap {
                position: relative;
                width: 6rem;
                height: 2rem;
                @include bg('round_wrap1');
                margin: auto;

                .course_shadow {
                    position: absolute;
                    width: 0.72rem;
                    height: 2rem;
                    top: 0;
                    pointer-events: none;
                    z-index: 3;

                    &.course_shadow1 {
                        left: 0;
                        @include bg('course_shadow1');
                    }

                    &.course_shadow2 {
                        right: 0;
                        @include bg('course_shadow2');
                    }
                }

                .swiper_box {
                    width: 100%;
                    margin: auto;

                    .slide_item {
                        margin: 0 0.04rem;

                        .gift_bg {
                            width: 1.4rem;
                            height: 1.6rem;
                            @include bg('reward_bg1');
                            padding-top: 0;

                            .img {
                                width: 1rem;
                                height: 1rem;
                                margin: auto;

                                img {
                                    max-width: 100%;
                                    max-height: 90%;
                                }
                            }

                        }

                        .name {
                            width: 1.26rem;
                            height: 0.26rem;
                            margin: 0 auto 0;
                            color: #6600AE;
                            text-align: center;

                            :deep(.notice_inner) {
                                font-size: 0.24rem;
                                font-weight: 700;
                            }
                        }

                        .text {
                            color: #6600AE;
                            text-align: center;
                            font-size: 0.22rem;
                        }
                    }
                }

            }
        }

        &.course_wrap5 {
            width: 6.5rem;
            height: 3.26rem;
            @include bg('course_wrap2');

            .course_swiper_wrap {
                position: relative;
                width: 6rem;
                height: 2rem;
                @include bg('round_wrap1');
                margin: 0.28rem auto 0;
                gap: 0.34rem;

                .hour_icon {
                    width: 1.64rem;
                    height: 1.64rem;
                    @include bg('hour_icon');
                    padding-top: 1rem;
                    text-align: center;

                    .num {
                        position: relative;

                        >div {
                            width: 100%;
                            height: 100%;
                            font-size: 0.22rem;
                            font-weight: 700;
                            color: #F9CB00;
                            line-height: 0.22rem;
                            text-align: center;
                        }

                        .up {
                            position: absolute;
                            background: linear-gradient(180deg, #FFF4B7 16.5%, #F9CB00 100%);
                            background-clip: text;
                            -webkit-background-clip: text;
                            -webkit-text-fill-color: transparent;
                            top: 0;
                        }
                    }
                }

                .text {
                    width: 3.5rem;
                    color: #FFED8D;
                    font-size: 0.24rem;
                    white-space: pre-wrap;
                }
            }
        }
    }
}

#EG,#ME {
    .home {
        .course_wrap {
            .round_wrap {
                .round_list {
                    .round_item {
                        .line {
                            left: unset;
                            right: 0;
    
                            &.line1 {
                                left: unset;
                                right: 45%;
                                background: linear-gradient(-90deg, #FF00AC -22.09%, #FFA800 -7.14%, #ffab30 100%);
                            }
    
                            &.line2 {
                                background: linear-gradient(-90deg, #ffab30 0%, #ffb53a 100%);
                            }
    
                            &.line3 {
                                background: linear-gradient(-90deg, #ffb53a 0%, #ffce57 100%);
                            }
    
                            &.line4 {
                                background: linear-gradient(-90deg, #ffce57 0%, #ffce57 100%);
                            }
    
                            &.line5 {
                                background: linear-gradient(-90deg, #ffce57 0%, #ffc74f 100%);
                            }
    
                            &.line6 {
                                background: linear-gradient(-90deg, #ffc74f 0%, #FFFB9D 100%);
                            }
                        }
                    }
                }
            }
    
            &.course_wrap2 {
                .round_wrap {
                    .round_list {
                        .round_item {
                            .line {
                                &.line2 {
                                    background: linear-gradient(-90deg, #FF00AC -22.09%, #FFA800 -7.14%, #ffb53a 100%);
                                }
    
                                &.line3 {
                                    background: linear-gradient(-90deg, #ffb53a 0%, #ffce57 100%);
                                }
    
                                &.line4 {
                                    background: linear-gradient(-90deg, #ffce57 0%, #ffc74f 100%);
                                }
    
                                &.line5 {
                                    background: linear-gradient(-90deg, #ffc74f 0%, #FFFB9D 100%);
                                }
                            }
                        }
                    }
                }
    
            }
    
            &.course_wrap3 {
                .round_wrap {
                    .round_list {
                        .round_item {
                            .line {
    
                                &.line2 {
                                    background: linear-gradient(-90deg, #FF00AC -22.09%, #FFA800 -7.14%, #ffb53a 100%);
                                }
    
                                &.line3 {
                                    background: linear-gradient(-90deg, #ffb53a 0%, #ffce57 100%);
                                }
                            }
                        }
                    }
                }
    
            }
        }
    
        .share_wrap {
            .reward_wrap {
                .count {
                    left: unset;
                    right: -0.006rem;
                }
            }
        }
    }
}
</style>